export default function NotFound() {
  return <div>URL Not found.</div>;
}
